import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Table, Column, Row, IconButton, Button, Card, Tag } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';
import { ExpandIcon, RefreshIcon } from 'components/Icons';
import { UserAvatar } from 'components/UserAvatar';

import { useProjectProfile } from '../context';

import { getTimestampDisplay } from 'utils/date';

export function ProjectTrackerList() {
  const { t } = useLang();

  const { project } = useProjectProfile();

  const trackers = loaders.projects.existingTrackerWaves.use({
    defaultValue: [],

    params: {
      origin: project.originProject || project.id,
    },
  });

  return (
    <>
      <Column gap="6" className="mt-2">
        <Row justifyContent="space-between">
          <Column gap="1">
            <h6 className="phone:text-lg">{t('tracker-info')}</h6>
            <span className="text-sm text-muted-foreground/50">{t('all-trackers-here')}</span>
          </Column>

          <IconButton size="small" tooltipContent="Refresh" onClick={trackers.retry}>
            <RefreshIcon size={20} />
          </IconButton>
        </Row>

        <Card>
          <Table
            items={trackers.data}
            loading={trackers.loading}
            spacing="medium"
            uniqueKey="id"
            columns={[
              {
                label: t('project'),
                render: ({ id, name }) =>
                  id === project.id ? (
                    <Row>
                      <span>{name}</span>

                      <Tag color="primary" name={t('open')} size="tiny" round={false} />
                    </Row>
                  ) : (
                    <Button
                      variant="link"
                      to="projectProfile"
                      params={{ projectId: id }}
                      className="text-inherit"
                      disabled={id === project.id}
                    >
                      {name}
                    </Button>
                  ),
              },

              {
                label: t('type')!,
                property: 'type',
                render: ({ type }) => t(type),
              },

              {
                label: t('created-at')!,
                property: 'createdAt',
                render: ({ createdAt }) => getTimestampDisplay(createdAt),
              },

              {
                label: t('finished-at')!,
                property: 'completedAt',
                render: ({ completedAt }) => (completedAt ? getTimestampDisplay(completedAt) : '-'),
              },

              {
                label: t('owner')!,

                render: ({ owner }) => <UserAvatar user={owner} name />,
              },

              {
                label: t('status'),
                className: 'text-center',
                render: ({ status }) => (
                  <EntityStatusTag target="project" status={status} size="medium" />
                ),
              },

              {
                render: ({ id }) =>
                  id !== project.id && (
                    <Row>
                      <IconButton
                        className="ml-auto"
                        to="projectProfile"
                        params={{ projectId: id }}
                      >
                        <ExpandIcon />
                      </IconButton>
                    </Row>
                  ),
              },
            ]}
          />
        </Card>
      </Column>
    </>
  );
}
